// @flow

import glamorous from 'glamorous';
import { compose, withHandlers, withProps } from 'recompose';
import { padding, rgba } from 'polished';

const ChallengeInfoTab = glamorous('button')(
  ({ theme }) => ({
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    fontSize: theme.fontSize.small,
    lineHeight: 1,
    outline: 'none',
    ...padding(10, 6),
    textTransform: 'uppercase'
  }),
  ({ active, theme }) =>
    active
      ? {
          backgroundColor: rgba(theme.color.basis2, 0.1),
          color: theme.color.basis2
        }
      : {
          color: theme.color.basis3
        }
);

const enhancer = compose(
  withProps({
    type: 'button'
  }),
  withHandlers({
    onClick: ({ id, onSelect }) => () => {
      onSelect(id);
    }
  })
);

export default enhancer(ChallengeInfoTab);
